import axios from 'axios';
import { clearAuthSession, getRefreshToken, setAuthSession } from './auth-storage';

export const TOKEN_REFRESH_PATH = '/api/api/token/refresh/';

export const refreshAccessToken = async () => {
  try {
    const refreshToken = getRefreshToken();
    if (!refreshToken) throw new Error('No refresh token available');

    const response = await axios.post(TOKEN_REFRESH_PATH, {
      refresh: refreshToken,
    });

    setAuthSession({ accessToken: response.data.access, refreshToken });
    return response.data.access;
  } catch (error) {
    console.error('Token refresh failed:', error);
    clearAuthSession();
    const loginPath = window.location?.pathname || '';
    if (!loginPath.startsWith('/login')) {
      window.location.href = '/login';
    }
    throw error;
  }
};

export const logout = () => {
  clearAuthSession();
  window.location.href = '/login';
};
